<template>

  <div>

    <div :id="_uid" class="ui small modal" :class="modalSelector">
      <div class="ui header">
        Solicitação de Complemento do Laudo
      </div>
      <div v-if="cert" class="content">
        <div class="ui form">
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Número do Laudo</label>
              <input :value="cert.id" readonly="readonly">
            </div>
            <div class="twelve wide field">
              <label class="form-label">Solicitante</label>
              <input :value="$store.state.auth.user.name + ' ' + $store.state.auth.user.lastName" readonly="readonly">
            </div>     
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Responsável pelo Complemento <span class="red text">*</span></label>
              <user-picker ref="userPicker" :onlySimavet="true" @onPick="onPickResponsible" @onClear="responsible = null" />
            </div>     
          </div>
          <div class="fields">            
            <div class="sixteen wide field">
              <label class="form-label">Observações</label>
              <textarea rows="5" v-model="comments"></textarea>
            </div>     
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i> Cancelar
        </button>              
        <button class="ui blue button" :class="{ loading: saving, disabled: !responsible }" @click="onConfirm()">
          <i class="checkmark icon"></i> Confirmar
        </button>
      </div>
    </div>

  </div>
  
</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"
  import UserPicker from "@/components/user-picker"

  export default {

    name: "ComplementRequestModal",

    data() {
      return {
        responsible: null,
        comments: "",
      }
    },

    mixins: [modalDialog],

    props: ["cert"],

    components: {
      UserPicker,
    },
    
    methods: {

      onPickResponsible(user) {
        this.responsible = user
      },

      async onConfirm() {

        const request = {
          certId: this.cert.id,
          requesterId: this.$store.state.auth.user.id,
          responsibleId: this.responsible.id,
          comments: this.comments,
        }

        this.emit("onConfirm", request)       
      },
    },
  }

</script>
